/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MarkUserStopResponse interface.
 */
export function instanceOfMarkUserStopResponse(value) {
    if (!('marked' in value) || value['marked'] === undefined)
        return false;
    return true;
}
export function MarkUserStopResponseFromJSON(json) {
    return MarkUserStopResponseFromJSONTyped(json, false);
}
export function MarkUserStopResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marked': json['marked'],
    };
}
export function MarkUserStopResponseToJSON(json) {
    return MarkUserStopResponseToJSONTyped(json, false);
}
export function MarkUserStopResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marked': value['marked'],
    };
}
